<template>
  <div style="background-color: #f5f6fa">
    <div style="background-color: #3f78f6">
      <van-sticky>
        <van-nav-bar
          style="background-color: #3f78f6; margin-bottom: 0rem; border: 0"
          title=""
          left-text=""
          left-arrow
          @click-left="onClickLeft"
        >
          <template #title>
            <span style="color: white; font-size: 0.4rem">{{ title }}</span>
          </template>
          <template #left>
            <van-icon name="arrow-left" color="white" size="18" />
          </template>
        </van-nav-bar>
      </van-sticky>
    </div>
    <section class="van-doc-demo-section">
      <div class="vant-table" style="margin: 0.2rem 0.3rem 0 0.3rem">
        <table
          cellspacing="0"
          style="background-color: white; width: 100%"
          class="table"
        >
          <tr>
            <th class="th" v-for="(item, index) in option.column" :key="index">
              {{ item.label }}
            </th>
          </tr>
          <tr v-for="(item, index) in tableData" :key="index">
            <td v-for="(context, i) in option.column" :key="i" class="list-tr">
              {{ item[context.prop] }}
            </td>
          </tr>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      typeg: "",
      title: "",
      code: "",
      bgcolor: Object,
      tableData: [],
      option: {
        column: [
          {
            label: "姓名",
            prop: "name",
          },
          {
            label: "学号",
            prop: "personal_number",
          },
        ],
      },
    };
  },
  created() {
    var typeg = this.$route.query.type;
    var title = this.$route.query.title;
    this.typeg = typeg;
    this.title = title;
    var json = window.localStorage.getItem("User");
    var jsonObj = JSON.parse(json);
    var code;
    if (jsonObj[0]["shenfen"] == "老师" || jsonObj[0]["shenfen"] == "学生") {
      code = jsonObj[0]["number"];
    } else if (jsonObj[0]["shenfen"] == "学生") {
      code = jsonObj[0]["number"];
    } else {
      code = jsonObj[0]["phone"];
    }
    //调用API参数格式化
    var params_json = {
      userid: code,
      action: "myStudentsDetail",
      param1: this.typeg,
      param2: "",
      param3: "",
      param4: "",
      param5: "",
    };
    //获取学生数组列表
    this.$http.post("/web/list", params_json).then(function (res) {
      console.log(res.data);
      this.tableData = res.data["rows"];
    });
    this.onLoad();
  },
  methods: {
    onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      setTimeout(() => {
        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (this.tableData.length >= this.tableData.length) {
          this.finished = true;
        }
      }, 1000);
    },
    //左上角页面跳转
    onClickLeft() {
      this.$router.push("MySchool");
    },
  },
};
</script>

<style>
.table {
  border-radius: 0.185185rem;
}

.th {
  font-size: 0.35rem;
  height: 1.074074rem;
  line-height: 1.074074rem;
  border-bottom: 0.01rem solid #eaeaea;
  text-align: center;
  border-top-left-radius: 0.185185rem;
  border-top-right-radius: 0.185185rem;
}

.list-tr {
  font-size: 0.35rem;
  text-align: center;
  height: 1.074074rem;
  line-height: 1.074074rem;
  border-bottom: 0.01rem solid #eaeaea;
}
</style>